module.exports = __webpack_public_path__ + "img/icon_service.ae0fece.webp";